import rawRequest from '@/utils/raw-request.js';

const queryVirusTripById = ( id ) => {
  return rawRequest( {
    url : 'https://2019ncov.133.cn/virus-trip/findByIds',
    // url : 'http://39.96.2.155/virus-trip/findByIds',

    data : {
      ids : id
    }
  } ).then( ( data ) => {
    console.log( '[ queryVirusTripById ]', data );

    return Promise.resolve( data.body.data );
  } );
};

export default queryVirusTripById;



// WEBPACK FOOTER //
// ./src/projects/virusTrip/service/query-virus-trip-by-id.js